<!--  试题搜索知识树递归模块   -->
<template>
    <div class="el-tree-node" :class="{'father-node':root==0}" v-if="filterShow">
        <div v-if="item.children&&item.children.length" :style="{paddingLeft:(this.root-1)*16+'px'}" class="el-tree-node__content"
             :class="computedbg" @click.stop="showbg()">
            <span class="el-tree-node__expand-icon" :class="{expanded:showchild}" @click.stop="showTree()"></span>
            <span class="el-tree-node__label">{{item.label}}</span>
        </div>

        <div v-else :style="{paddingLeft:(this.root-1)*16+'px'}" class="el-tree-node__content" @click.stop.prevent="showId()" :class="computedbg">
            <label class="el-checkbox" v-if="treeType == 1">
                <span class="el-checkbox__input" :class="computedcheck">
                    <span class="el-checkbox__inner"></span>
                    <input type="checkbox" class="el-checkbox__original" value="">
                </span>
            </label>
            <span v-if="treeType == 2" style="display='inline-block';width:32px;"></span>
            <span class="el-tree-node__label">{{item.label}}</span>
        </div>

        <div v-if="item.children&&item.children.length">
            <tree-item
                    ref='treeItem'
                    v-for="(item,index) in item.children"
                    :item="item"
                    :root="nowroot"
                    v-show="showchild"
                    :idList="idList"
                    class="el-tree-node__children"
                    :check="ischecked"
                    :state="state"
                    :key="index"
                    :filterText="filterText"
                    :treeType="treeType"
                    @tree-change="treeChange"
            ></tree-item>
        </div>
    </div>
</template>

<style scoped>
    .el-tree-node__content > .el-checkbox,.el-tree-node__content > .el-radio {
        margin-left: 16px;
    }
</style>

<script>
    export default {
        data(){
            return {
                // 是否显示子节点
                showchild: false,
                // 当前节点id
                // 当前节点是否选中
                ischecked: this.check,
                // 当前节点深度
                nowroot: this.root + 1
            }
        },
        name: 'treeItem',
        props: ['item', 'root', 'idList', 'check', 'state','filterText','treeType'],
        created: function () {
            if (this.root == 1) {
                this.showchild = true;
            }
        },
        methods: {
            // 展开收起全部知识点
            showHidden: function (data) {
                this.showchild = data;
                if(this.$refs.treeItem) {
                    for (var item of this.$refs.treeItem) {
                        item.showHidden(data);
                    }
                }
                if (this.root == 1) {
                    this.showchild = true;
                }
            },

            // 展示当前选中背景，并且将父节点id添加到idlist中
            showbg: function () {
                // 清空背景数组
                this.state.bgList.splice(0, this.state.bgList.length);
                // 将当前id传给背景数组
                this.state.bgList.push(this.item.id);

                // 清空idlist数组
                this.idList.splice(0, this.idList.length);
                this.idList.push(this.item);

                // 将点击了父节点标志位置为true
                this.state.parentclick = true;
                this.treeChange()
            },

            // 展示子节点
            showTree: function () {
                this.showchild = !this.showchild;
            },

            // 展示子节点ID
            showId: function () {
                if(this.treeType == 2){
                    // 清空背景数组
                    this.state.bgList.splice(0, this.state.bgList.length);
                    // 将当前id传给背景数组
                    this.state.bgList.push(this.item.id);
                    this.idList.length = 0;
                    this.state.parentclick = false;
                }
                // 如果点击过父节点，再次点击叶子节点前应清空idlist数组
                if (this.state.parentclick == true) {
                    this.state.parentclick = false;
                    this.idList.splice(0, this.idList.length);
                    this.state.bgList = [];
                }
                // 当选中时，将ID添加到结果数组
                if (this.ischecked != true) {
                    var _this = this;
                    var flag = false;
                    // 如何当前list有当前id，不插入
                    this.idList.forEach(function (el) {
                        if (_this.item.id == el) {
                            flag = true;
                        }
                    })

                    // 当前list没有id，插入
                    if (flag != true) {
                        this.idList.push(this.item);
                        flag = false;
                    }
                } else {
                    // 当未选中时，将当前id从idlist中删除
                    var _this = this;
                    this.idList.forEach(function (el, index, arr) {
                        if (el.id == _this.item.id) {
                            arr.splice(index, 1);
                        }
                    })
                    this.ischecked = false;
                }
                this.treeChange()
            },
            getFilterInfo(item){
                let content = ''
                for(let i = 0; i<item.length; i++){
                    content += item[i].label
                    if(item[i].children&&item[i].children.length){
                        content += this.getFilterInfo(item[i].children)
                    }
                }
                return content
            },
            treeChange(){
                this.$emit('tree-change')
            }
        },
        computed: {
            // 计算当前单选框是否选中
            computedcheck: function () {
                var _this = this;
                var flag = false;

                this.idList.forEach(function (el) {
                    if (_this.item.id == el.id) {
                        flag = true;
                    }
                })

                // 当前id在idlist数组中，表示选中
                if (flag == true) {
                    this.ischecked = true;
                    return 'isChecked';
                }

                // 当前id不在idlist数组中，表示未选中
                if (flag == false) {
                    this.ischecked = false;
                    return '';
                }
            },
            // 计算当前背景是否选中
            computedbg: function () {
                if (this.state.bgList[0] && this.state.bgList[0] == this.item.id) {
                    return 'showbg';
                }
                else {
                    return '';
                }
            },
            filterShow(){
                if(!this.filterText) return true
                let content = this.getFilterInfo([this.item])
                let state = content.includes(this.filterText)
                return state
            }
        },
        watch: {
            filterText(val){
                if(val == ''){
                    this.showchild = false;
                    if (this.root == 1) {
                        this.showchild = true;
                    }
                }else{
                    this.showchild = true;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// packages/question-tree/src/treeItem.vue